goog.require('el8.template.multiuser_access.securityQAReset');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');
goog.require('el8.service.tooltip');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.securityQAReset = (function() {

    var that = {};

    var userProfileId = null;
    var faxCode = null;
    var theForm = null;
    var securityQAResetToken = null;

    function submitNewQA() {



        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('submitNewQA', [faxCode, userProfileId, securityQAResetToken]),
            data: JSON.stringify({
                question: theForm.getVal('question'),
                answer: theForm.getVal('answer')
            }),
            async: true,
            success: function(data) {
                if (data.location) {
                    location.href=data.location;
                } else {
                    location.href='/efax/error/';
                }
            }
        });
    }

    function inputChanged() {
        var question = theForm.getVal('question');
        var answer = theForm.getVal('answer');

        if (question && answer) {
            $('#go-to-chart').prop('disabled', false);
        } else {
            $('#go-to-chart').prop('disabled', true);
        }
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);

    function setupKeyPressedListeners() {
        $(document).on('keypress', ':input[name="answer"]', debouncedInputChanged);
    }

    function initializeTooltips() {
        el8.service.tooltip.create({
            anchor: $('.securityQ-icon'),
            text: el8.template.multiuser_access.signup.securityQTooltip()
        });
    }


    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        userProfileId = spec.userProfileId;
        faxCode = spec.faxCode;
        securityQAResetToken = spec.securityQAResetToken;
        var securityQuestions = spec.securityQuestions;

        $('.main-content').html(
            el8.template.multiuser_access.securityQAReset.content({
                securityQuestions: securityQuestions
            })
        );

        theForm = new el8.uiwidget.Form({
            fields: [{
                name: 'question',
                selector: ':input[name="question"]',
                changeFn: function() {
                    inputChanged();
                }
            },
            {
                name: 'answer',
                selector: ':input[name="answer"]',
                maxLength: 30,
                changeFn: function() {
                    inputChanged();
                }
            }],
            container: $('#main-form')
        });
        theForm.render();

        setupKeyPressedListeners();

        initializeTooltips();

        inputChanged();

        $(document).on('click', '#go-to-chart', function(event) {
            submitNewQA();
        });
    };

    return that;

})();